module.exports = __webpack_public_path__ + "img/Inflate Tyre.0c6d9728.png";